import { useState } from 'react';
import { AnchorAPI } from '../../../modules/AnchorAPI';
import {
  FetchWordPressPostMetadataParams,
  WORDPRESS_POST_ERRORS,
} from '../../../modules/AnchorAPI/v3/wordpress/fetchWordPressPostMetadata';

export enum POST_CONTENT_STATE {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
export function usePostContent({
  webStationId,
  postMetadataId,
}: { webStationId: string | null } & Pick<
  FetchWordPressPostMetadataParams,
  'postMetadataId' | 'isSiteMetadataIncluded' | 'isContentIncluded'
>) {
  const [postContent, setPostContent] = useState<string | null>(null);
  const [errors, setErrors] = useState<WORDPRESS_POST_ERRORS[]>([]);
  const [postContentState, setPostContentState] = useState<POST_CONTENT_STATE>(
    POST_CONTENT_STATE.IDLE
  );

  function handleFetchWordPressPostMetadata() {
    return new Promise((resolve, reject) => {
      if (webStationId && postMetadataId) {
        setPostContentState(POST_CONTENT_STATE.LOADING);
        AnchorAPI.fetchWordPressPostMetadata({
          webStationId,
          postMetadataId,
          isContentIncluded: true,
        })
          .then(res => {
            const {
              post: { content, errors: wpErrors },
            } = res;
            setPostContent(content);
            setPostContentState(POST_CONTENT_STATE.SUCCESS);
            if (wpErrors) setErrors(wpErrors);
            resolve();
          })
          .catch(err => {
            setPostContentState(POST_CONTENT_STATE.ERROR);
            reject(
              new Error(
                `unable to fetch wordpress post metadata: ${err.message}`
              )
            );
          });
      } else {
        setPostContentState(POST_CONTENT_STATE.ERROR);
        reject(new Error('web station id nad post metadata id is not set'));
      }
    });
  }

  return {
    postContent,
    postContentState,
    handleFetchWordPressPostMetadata,
    errors,
  };
}
